<div class="section pb-0">
    <div class="spacer spacer-lg light-bg"></div>
    <div class="container">
        <div class="section-title text-center">
            <p class="subtitle">02 --- Our Accomodations </p>
            <h4 class="title">Choose Accomodation</h4>
        </div>
        <div class="row">
            <!-- Data -->
            <div class="col-lg-4 col-md-6" *ngFor="let item of blockcta">
                <div class="sigma_portfolio-item style-6">
                    <img [src]="item.image" alt="portfolio">
                    <div class="sigma_portfolio-item-content">
                        <div class="sigma_portfolio-item-content-inner">
                            <h5> <a routerLink="/case-studies"> {{item.title}} <i class="fal fa-arrow-right"></i> </a> </h5>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Data -->
        </div>
    </div>
</div>